module.exports = __webpack_public_path__ + "img/exam_jan_2025_1ugk02f6.8ff99daa.jpg";